import { openIndexedDB } from './openIndexedDB'

export async function loadImagesFromIndexedDB(id: number): Promise<File> {
  const db = await openIndexedDB()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(['images'], 'readonly')
    const store = transaction.objectStore('images')
    const request = store.get(id)

    request.onsuccess = (event) => {
      const result = (event.target as IDBRequest).result
      if (result) {
        if (result.fileData && result.fileType) {
          const blob = new Blob([result.fileData], { type: result.fileType })
          const file = new File([blob], result.fileName, { type: result.fileType })
          resolve(file)
        } else if (result.file) {
          resolve(result.file)
        } else {
          reject('Arquivo não encontrado')
        }
      } else {
        reject('Arquivo não encontrado')
      }
    }

    request.onerror = (event) => {
      reject(`Erro ao recuperar arquivo: ${event}`)
    }
  })
}
